import React from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import clsx from "clsx";
import { useApacHotelsStyles } from "../../hooks";
import { ApacHotelsComponent } from "../../types";
import defaultStyles from "./styles.module.scss";

export type RewardsAndCreditsLineItem = {
  label: React.ReactNode;
  value: React.ReactNode;
  className?: "positive" | "discount";
};

interface RewardsAndCreditsBreakdownSectionProps
  extends PlatformComponentProps {
  lineItems: RewardsAndCreditsLineItem[];
}

const COMPONENT_KEY = ApacHotelsComponent.RewardsAndCredit;

export const RewardsAndCreditsBreakdownSection: React.FC<
  RewardsAndCreditsBreakdownSectionProps
> = ({ lineItems, className }) => {
  const styles = useApacHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  if (!lineItems?.length) {
    return null;
  }

  return (
    <div className={clsx(block, className)}>
      {lineItems.map((item, i) => (
        <div className={cn("container")} key={`line-item-${i}`}>
          <div className={cn("item-label")}>{item.label}</div>
          <div className={cn("item-value", { [item.className ?? ""]: true })}>
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
};
